// Configuración de la landing.
// URL de la app del mapa Bestigium: los CTAs enlazan directamente aquí.
export const APP_URL = 'https://app.bestigium.com';

// Versión visible en la UI (fuente única de verdad: package.json, inyectada por Vite).
export const APP_VERSION: string = import.meta.env.VITE_APP_VERSION ?? '0.0.0';
